import React from "react";

function IconReport() {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="17.064"
    height="21.5"
    viewBox="0 0 17.064 21.5"
  >
    <defs>
      <ellipse
        id="ellipse-12"
        cx="8.516"
        cy="11.604"
        rx="0.811"
        ry="0.811"
      ></ellipse>
    </defs>
    <path
      fill="none"
      stroke="#818182"
      strokeDasharray="0 0 0 0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M14.081 20.747H2.971A2.222 2.222 0 01.75 18.525V2.972C.75 1.745 1.745.75 2.972.75h8.132l5.21 5.144v12.642a2.222 2.222 0 01-2.233 2.211h0z"
    ></path>
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M11.282 1.361v3.122c0 .89.721 1.61 1.61 1.61h3.122"
    ></path>
    <path
      fill="none"
      stroke="#818182"
      strokeDasharray="0 0 0 0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M11.282 1.361v3.122c0 .89.721 1.61 1.61 1.61h3.122"
    ></path>
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M11.804 7.96a4.91 4.91 0 011.622 3.655 4.855 4.855 0 01-1.6 3.622"
    ></path>
    <path
      fill="none"
      stroke="#818182"
      strokeDasharray="0 0 0 0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M11.804 7.96a4.91 4.91 0 011.622 3.655 4.855 4.855 0 01-1.6 3.622"
    ></path>
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M5.216 15.248a4.921 4.921 0 010-7.288"
    ></path>
    <path
      fill="none"
      stroke="#818182"
      strokeDasharray="0 0 0 0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M5.216 15.248a4.921 4.921 0 010-7.288"
    ></path>
    <g>
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M10.426 9.493c.602.542.945 1.313.945 2.122a2.81 2.81 0 01-.934 2.1"
      ></path>
      <path
        fill="none"
        stroke="#818182"
        strokeDasharray="0 0 0 0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.426 9.493c.602.542.945 1.313.945 2.122a2.81 2.81 0 01-.934 2.1"
      ></path>
    </g>
    <g>
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M6.571 13.715a2.877 2.877 0 01-.933-2.111 2.822 2.822 0 01.933-2.11"
      ></path>
      <path
        fill="none"
        stroke="#818182"
        strokeDasharray="0 0 0 0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.571 13.715a2.877 2.877 0 01-.933-2.111 2.822 2.822 0 01.933-2.11"
      ></path>
    </g>
    <g>
      <use fill="#FFF" xlinkHref="#ellipse-12"></use>
      <use
        fillOpacity="0"
        stroke="#818182"
        strokeDasharray="0 0 0 0"
        strokeLinecap="round"
        strokeLinejoin="round"
        xlinkHref="#ellipse-12"
      ></use>
    </g>
  </svg>
  );
}

export default IconReport;
